 
import React from "react";
import { PageLoader } from "../../../../../../../components/PageLoader/PageLoader";
import { StandadCard } from "../../../../../../../components/Cards";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../../redux/initialStoreState";
import { LoadState, MODULE_IDS } from "../../../../../../../constants/enums";
import { useDispatchWrapper, useBreadcrumb, useCustomerPolicyDetails } from "../../../../../../../hooks";
import { useFormik } from "formik";
import { Box, Grid } from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import { useNavigate, useParams } from "react-router-dom";
import { RoleBasedCustomButton } from "../../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { addAutomobileSharingFillableAsync, clearAutomobilePolicyFormsState, fetchAutomobileSharingFillableAsync } from "../../../../../../../redux/automobilePolicyForms/automobilePolicyFormsActions";
import { PageContainer } from "../../../../../../../components/container/PageContainer";
import { useAutomobileApplicationList } from "../../hooks/useAutomobileApplicationList";

export const AutomobileSharingFillable: React.FC<{isDuplicate?: boolean}> = (props) => {
  const { customerId, customerPolicyId, serialNumber } = useParams() as {
    customerId?: number;
    customerPolicyId?: number;
    serialNumber?: number;
  };

  useBreadcrumb({
    title: "",
    items: [
    {
      to: "/dashboard",
      title: "dashboard",
    },
    {
      to: "/view-customers",
      title: "customers",
    },
    {
      to: "/customer-overview/" + customerId,
      title: "customer-overview",
    },
    {
      title: "sharing fillable",
    },
  ],
  });


  const { isDuplicate } = props;
const isUpdate = serialNumber ? true : false;

  React.useEffect(() => {
    return () => {
      dispatch(clearAutomobilePolicyFormsState());
    };
  }, []);

  const { data:sharing, loading:sharingLoading, error } = useSelector(
    (storeState: IStoreState) => storeState.automobile.policyForms.rideSharing
  );
  const { details: policyAdmin } = useCustomerPolicyDetails(customerPolicyId);
  const { applicationDropdown, defaultApplicationNumber, loading: appListLoading } = useAutomobileApplicationList(customerPolicyId);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: sharing,
    validate: (values) => { },
    onSubmit: (values) => {
      if (customerPolicyId && customerId) {
        setSaveLoading(true);
        dispatch(
          addAutomobileSharingFillableAsync(
            {
              ...values,
              customer_id: customerId,
              producer_one_id: policyAdmin?.data?.producer_one,
              producer_one_code: policyAdmin?.data?.producer_one_code,
              customer_policy_id: customerPolicyId,
              application_number: values.application_number ? Number(values.application_number) : null,
            },
            sharing,
            isUpdate,
            (isSuccess) => {
              if (isSuccess) {
                window.scrollTo(0, 0);
                navigate(
                  `/automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}?tab=0`
                );
              }
              setSaveLoading(false);
            },
            isDuplicate,
          )
        );
      }
    },
  });

  React.useEffect(() => {
    if (customerPolicyId && serialNumber) {
      dispatch(fetchAutomobileSharingFillableAsync(customerPolicyId, serialNumber));
    }
  }, [customerPolicyId, serialNumber]);

  React.useEffect(() => {
    if (!serialNumber) {
      setValues({
        ...sharing,
        customer_name: policyAdmin?.data?.customer_name,
        policy_number:
          policyAdmin?.data?.policy_number || policyAdmin?.data?.binder_number,
        producer_one_id: policyAdmin?.data?.producer_one,
        producer_one_code: policyAdmin?.data?.producer_one_code,
        application_number: defaultApplicationNumber,
      });
    } else {
      setValues(sharing);
    }
  }, [sharing, policyAdmin]);


  React.useEffect(() => {
    return () => {
      dispatch(clearAutomobilePolicyFormsState());
    };
  }, []);

  return (
    <PageContainer
            title={
              serialNumber
                ? "Edit  Ride Sharing "
                : "Create  Ride Sharing "
            }
            description="Manage sharing ."
          >
    <PageLoader
      loading={sharingLoading === LoadState.InProgress}
      error={error ? { message: error } : undefined}
    >
      <StandadCard sx={{ mt: 2 }} heading="Ride Sharing">
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Application Number</CustomFormLabel>
              <ControlledCustomSelect
                fullWidth
                value={values.application_number ?? ""}
                name="application_number"
                onChange={handleChange}
                placeholder="Select one"
                displayEmpty
                options={applicationDropdown}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Customer Name</CustomFormLabel>
              <CustomTextField
                name="customer_name"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                disabled
                value={values.customer_name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomFormLabel>Policy Number</CustomFormLabel>
              <CustomTextField
                name="policy_number"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                disabled
                value={values.policy_number}
                onChange={handleChange}
              />
            </Grid>
            

            <Grid item xs={12} lg={3}>
              <CustomFormLabel>Status</CustomFormLabel>
              <ControlledCustomSelect
                name="status"
                variant="outlined"
                size="small"
                type="text"
                fullWidth
                displayEmpty
                placeholder="Select One"
                options={[
                  { label: "Active", value: "ACTIVE" },
                  { label: "Inactive", value: "INACTIVE" },
                ].map((data) => {
                  return { label: data.label, value: data.value };
                })}
                value={values.status}
                onChange={handleChange}
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 4 }}>
            <RoleBasedCustomButton
              sx={{ width: "15%" }}
              disabled={saveLoading}
              variant="contained"
              moduleKey={MODULE_IDS.COMMERCIAL_AUTO}
              type="submit"
            >
              Save
            </RoleBasedCustomButton>
          </Box>
        </form>
      </StandadCard>
      {/* </CustomerBaiscDetailsLayout> */}
    </PageLoader>
    </PageContainer>
  );
};
